var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.262 2.675c-.039 0-.075.009-.113.011h-3.085v-.011l-21.212.011c-.039-.002-.075-.011-.114-.011a2.132 2.132 0 0 0-1.5 3.647l4.699 4.699v-.348c0 4.825 3.774 8.759 8.53 9.036v8.551h-4.265v1.066h9.596V28.26h-4.265v-8.551c4.756-.277 8.53-4.211 8.53-9.036v.348l4.699-4.699a2.132 2.132 0 0 0-1.501-3.646zM6.937 9.512 2.988 5.563a1.067 1.067 0 0 1 .707-1.821l.099.009.029.002h3.114v5.76zm17.06 1.16c0 4.41-3.588 7.997-7.997 7.997s-7.997-3.587-7.997-7.997V3.741h15.994v6.931zm5.015-5.109-3.949 3.949v-5.76l3.143-.002c.034-.002.067-.005.099-.009a1.068 1.068 0 0 1 1.023 1.065c0 .286-.113.554-.316.756z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.b8d44aa8ed1e8eee97070f698c1063a4.svg";
export { ForwardRef as ReactComponent };